export default {
  __name: 'AppStreamerAwardsAwardModal',
  props: {
  image: { type: String, required: true },
  icon: { type: String, required: true },
  isUnlocked: { type: Boolean, default: false },
  description: { type: String, default: '' },
  shopUrl: { type: String, required: true },
  text: { type: String, default: '' }
},
  setup(__props) {




return { __sfc: true, }
}

}